import { type Components } from '@webapp/api/integrations/client'

export type IntegrationSyncResponseStatus = Components.Schemas.SyncStatus

export const IntegrationSyncResponseStatuses: {
  [K in IntegrationSyncResponseStatus]: K
} = {
  CREATED: 'CREATED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
} as const
